import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const MainChartLegendContainer = styled.div`
  display: flex;
  margin-bottom: 30px;
  justify-content: center;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    justify-content: end;
  }
`;
